import React, { Component } from 'react';
import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router';
import Slider from 'material-ui/Slider';
import AppStore from '../../stores/app-store.js'
import { numeroJogadoresActions } from '../../actions/app-actions.js'
import { numeroCartasActions } from '../../actions/app-actions.js'
import './Info.css';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

const style = {
    margin: 12,
    float: 'right',
};

class Info extends Component {
    constructor() {
        super();
        this.state = {
            qtdJogadores: AppStore.getQtdJogadores(),
            qtdCartas: AppStore.getQtdCartas(),
            legendas: AppStore.legendas,
        };
        this.onChange = this.onChange.bind(this);
        this.onChangeCartas = this.onChangeCartas.bind(this);
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    trataQtdJogadores = (evento, valor) => {
        numeroJogadoresActions.definirNumero(valor);
        numeroCartasActions.definirNumero(valor);
    };

    trataQtdCartas = (evento, valor) => {
        numeroCartasActions.definirNumero(valor);
    };

    componentWillMount() {
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentDidMount() {
        AppStore.addChangeQtdJogListener(this.onChange);
        AppStore.addChangeQtdCartasListener(this.onChangeCartas);
    }

    componentWillUnmount() {
        AppStore.removeChangeQtdJogListener(this.onChange)
        AppStore.removeChangeQtdCartasListener(this.onChangeCartas)
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }

    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }


    onChange() {
        this.setState({
            qtdJogadores: AppStore.getQtdJogadores(),
        })
    }

    onChangeCartas() {
        this.setState({
            qtdCartas: AppStore.getQtdCartas(),
        })
    }



    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="Info">
                    <h2>{this.state.legendas.escolhaQuantidadeJogadores}</h2>
                    <Slider className="centralizado" style={{ width: 200 }} min={2} max={10} step={1} defaultValue={2} value={this.state.qtdJogadores} onChange={this.trataQtdJogadores} />
                    <h2>{this.state.legendas.quantidade}: {this.state.qtdJogadores}</h2>
                    <h2>{this.state.legendas.escolhaQuantidadeCartas}</h2>
                    <Slider className="centralizado" style={{ width: 200 }} min={this.state.qtdJogadores} max={36} step={this.state.qtdJogadores} defaultValue={12} value={this.state.qtdCartas} onChange={this.trataQtdCartas} />
                    <h2>{this.state.legendas.quantidade}: {this.state.qtdCartas}</h2>
                    <RaisedButton containerElement={<Link to="/carta1" />}
                        linkButton={true}
                        label={this.state.legendas.avancar}
                        style={style}
                        primary={true}
                    />
                </div>
            </MuiThemeProvider>
        );
    }
}

export default Info;


// WEBPACK FOOTER //
// ./src/componentes/info/Info.js